var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.isScreenWide? 'div' : _vm.ToggleModal,{tag:"component",staticClass:"ToggleModalOnlyForSmallScreen",attrs:{"fullScreen":true},scopedSlots:_vm._u([(!_vm.isScreenWide)?{key:"toggler",fn:function(){return [_vm._t("toggler")]},proxy:true}:null],null,true)},[(_vm.$slots.content)?_vm._t("content"):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }